import { useState, useEffect, useRef } from 'react'
import { CategoryBar, HighlightBar, EachCategory,MainConatiner,ListContainer ,Image,Button,Title} from "./style";

const certificates = [
    {
        id: 1,
        imageUrl: "https://media-content.ccbp.in/certificates/share/OSUSBTWZFK.png",
        name: "Build Your Own Static Website",
        category: 'Courses',
    },
    {
        id: 2,
        imageUrl: "https://media-content.ccbp.in/certificates/share/QXZMGIKGOL.png",
        name: "Python",
        category: 'Courses',
    },
    {
        id: 3,
        imageUrl: "https://media-content.ccbp.in/certificates/share/SXKXOMJQRL.png",
        name: "Build Your Own Responsive Website",
        category: 'Courses',
    },
    {
        id: 4,
        imageUrl: "https://media-content.ccbp.in/certificates/share/KUHDUMVKSX.png",
        name: "Build Your Own Dynamic Web Application",
        category: 'Courses',
    },
    {
        id: 5,
        imageUrl: "https://media-content.ccbp.in/certificates/share/HKCKURVFZQ.png",
        name: "Introduction to Databases",
        category: 'Courses',
    },
    {
        id: 6,
        imageUrl: "https://media-content.ccbp.in/certificates/share/MOGLJRBTMV.png",
        name: "JavaScript Essentials",
        category: 'Courses',
    },
    {
        id: 7,
        imageUrl: "https://media-content.ccbp.in/certificates/share/JWBVQWMFTA.png",
        name: "Responsive Web Design using Flexbox",
        category: 'Courses',
    },
    {
        id: 8,
        imageUrl: "https://media-content.ccbp.in/certificates/share/ZRWYWFMTGD.png",
        name: "Developer Foundations",
        category: 'Courses',
    },
    {
        id: 9,
        imageUrl: "https://media-content.ccbp.in/certificates/share/RYCYSWDPYX.png",
        name: "Node.js",
        category: 'Courses',
    },
    {
        id: 10,
        imageUrl: "https://media-content.ccbp.in/certificates/share/GIMMBPSIAE.png",
        name: "React JS",
        category: 'Courses',
    },
    {
        id: 11,
        imageUrl: "https://media-content.ccbp.in/certificates/share/LHYOGNUBHT.png",
        name: "XPM 4.0 Fundamentals",
        category: 'Mindset Developement'
    },
    {
        id: 12,
        imageUrl: "./images/cisco-cybersecurity.png",
        name: "Cisco Cybersecurity Essentials",
        category: "Courses",
    },
    {
        id: 13,
        imageUrl: "./images/azure-ai.png",
        name: "Microsoft Azure AI-900",
        category: "Courses",
    },
    {
        id: 14,
        imageUrl: "./images/aws-academy-graduate-aws-academy-cloud-foundations.png",
        name: "AWS Academy Cloud Foundations",
        category: "Others",
    },
    {
        id: 15,
        imageUrl: "./images/MKXPEONGKV.png",
        name: "UI/UX Workshop by Aman Maheswari",
        category: "Podcasts & Workshops",
    },
    {
        id: 16,
        imageUrl: "./images/KV1J7G8B3D.png",
        name: "Ms.Lalitha Tallapragada PepsiCo's Leader's Podcast",
        category: "Podcasts & Workshops",
    },
    {
        id: 17,
        imageUrl: "./images/80Y4ZM223O.png",
        name: "Mr.Shinpei Kato Autonomous vehicle Podcast",
        category: "Podcasts & Workshops",
    },
    {
        id: 18,
        imageUrl: "./images/ANEA442TCX.png",
        name: "Generative AI Mega Workshop 2.0 Project Completion Certificate",
        category: "Podcasts & Workshops",
    },
    {
        id: 19,
        imageUrl: "./images/M91XE5HMAD.png",
        name: "Generative AI Mega Workshop 2.0 Participation Certificate",
        category: "Podcasts & Workshops",
    },
    {
        id: 20,
        imageUrl: "./images/nxtwave-certificate.png",
        name: "Mr.Venkata Sailesh Software Engineer at Google Pursuing Masters Abroad Podcast",
        category: "Podcasts & Workshops",
    },
    {
        id: 21,
        imageUrl: "./images/ZPBW8ZB9S3.png",
        name: "DSA Codeverse: Contest#10",
        category: "Podcasts & Workshops",
    },
]
const categories = ['Courses', 'Podcasts & Workshops', "Mindset Developement", "Others"]
const Certifications = () => {
    const [viewMore,setViewMore] = useState(false)
    const [activeIndex, setActiveIndex] = useState(0); // index of category
    const categoryRefs = useRef([]);
    const [highlightStyle, setHighlightStyle] = useState({ left: 0, width: 0 });

    useEffect(() => {
        const activeEl = categoryRefs.current[activeIndex];
        if (activeEl) {
            setHighlightStyle({
                left: activeEl.offsetLeft,
                width: activeEl.offsetWidth
            });
        }
    }, [activeIndex]);

    const filteredCertificates = certificates.filter(certificate=>{
        if(certificate.category===categories[activeIndex]){
            return true
        }
        return false
    })
    let newCertificates;
    if(viewMore===false){
        newCertificates = filteredCertificates.slice(0,6)
    }else{
        newCertificates = filteredCertificates
    }
    
    const onClickViewMore = ()=>{
        setViewMore(prev=>!prev)
    }
    return (
        <MainConatiner>
            <Title>Certifications</Title>
            <CategoryBar>
                <HighlightBar left={highlightStyle.left} width={highlightStyle.width} />
                {categories.map((cat, idx) => (
                    <EachCategory
                        key={cat}
                        active={idx === activeIndex}
                        ref={el => (categoryRefs.current[idx] = el)}
                        onClick={() => {
                            setActiveIndex(idx)
                            setViewMore(false)
                        }}
                    >
                        {cat}
                    </EachCategory>
                ))}
            </CategoryBar>
            <ListContainer>
                {newCertificates.map(certificate => <Image src={certificate.imageUrl} key={certificate.id} alt={certificate.name} />)}
            </ListContainer>
            {filteredCertificates.length>6?<Button onClick={onClickViewMore}>{viewMore?"View Less":"View All"}</Button>:null}
        </MainConatiner>
    )
}
export default Certifications